import { render } from "./WarrantySettingList.vue?vue&type=template&id=5c82a230"
import script from "./WarrantySettingList.vue?vue&type=script&lang=js"
export * from "./WarrantySettingList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__